import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';
const PURCHASES = [{
  name: 'María José Pérez',
  city: 'Salta'
}, {
  name: 'Federico Álvarez',
  city: 'Tucumán'
}, {
  name: 'Lucía Mendoza',
  city: 'Mar del Plata'
}, {
  name: 'Martín Sosa',
  city: 'Córdoba'
}, {
  name: 'Carolina Fernández',
  city: 'Buenos Aires'
}, {
  name: 'Javier Romero',
  city: 'Rosario'
}, {
  name: 'Sofía Albornoz',
  city: 'Mendoza'
}, {
  name: 'Mariana Quiroga',
  city: 'La Plata'
}, {
  name: 'Diego Sánchez',
  city: 'Neuquén'
}, {
  name: 'Valeria Torres',
  city: 'Santa Fe'
}, {
  name: 'Agustina Ruiz',
  city: 'Bahía Blanca'
}, {
  name: 'Nicolás Herrera',
  city: 'San Juan'
}];
export const PurchasePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * (25000 - 15000 + 1) + 15000);
      setTimeout(showNextPopup, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-109">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 15
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-lg shadow-xl flex overflow-hidden max-w-sm border border-gray-100" data-id="element-110">
          <div className="w-2 bg-green-500" data-id="element-111"></div>
          <div className="p-4 flex items-start gap-3 relative" data-id="element-112">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-113">
              <X className="w-4 h-4" data-id="element-114" />
            </button>
            <div className="mt-1" data-id="element-115">
              <CheckCircle className="w-6 h-6 text-green-500" data-id="element-116" />
            </div>
            <div className="pr-6" data-id="element-117">
              <p className="text-xs text-green-600 font-bold mb-1 tracking-wider" data-id="element-118">
                COMPRA VERIFICADA
              </p>
              <p className="text-sm text-gray-800" data-id="element-119">
                <span className="font-semibold" data-id="element-120">{currentPurchase.name}</span> de{' '}
                {currentPurchase.city} acaba de comprar el{' '}
                <span className="font-semibold" data-id="element-121">
                  Kit Insomnio en Ansiedad y Depresión
                </span>
                .
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-122">Hace unos minutos</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};